import DistributionLoss from './distribution_loss/index'

export default {
  modules: {
    DistributionLoss
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/loss_system/index.js